import styled from "styled-components";

export const FinalCountdownDivStyled = styled.div`
  display: flex;
  justify-content: center;
  padding: 5vh 0 0 0;
`;

export const FinalCountStyled = styled.iframe`
  width: 50%;
  height: 315px;
  border: none;
  box-shadow: 0px 8px 0px 0.1px #16151d;
`;
